import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from '../components/ui/button';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_cb900e0f-c443-41f6-9df3-17a2db93c215/artifacts/qd501ira_D70BB6EE-7344-46BE-86BC-6C6D197A54F6.png";

export default function Header({ variant = "light" }) {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);

  const isLight = variant === "light";
  const textColor = isLight ? "text-slate-900" : "text-white";
  const hoverColor = isLight ? "hover:text-teal-700" : "hover:text-teal-300";

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 ${isLight ? 'glass border-b border-slate-100' : 'bg-transparent'}`}>
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
            <img src={LOGO_URL} alt="Resume Surgeon" className="h-10 w-10 md:h-12 md:w-12 rounded-xl" />
            <span className={`font-bold text-lg md:text-xl tracking-tight ${textColor}`} style={{ fontFamily: 'Outfit' }}>
              Resume Surgeon
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <Link to="/pricing" className={`text-sm font-medium ${textColor} ${hoverColor} transition-colors`} data-testid="nav-pricing">
              Pricing
            </Link>
            <Link to="/samples" className={`text-sm font-medium ${textColor} ${hoverColor} transition-colors`} data-testid="nav-samples">
              Samples
            </Link>
            <Link to="/faq" className={`text-sm font-medium ${textColor} ${hoverColor} transition-colors`} data-testid="nav-faq">
              FAQ
            </Link>

            <Button 
              onClick={() => navigate('/start')} 
              className="bg-slate-900 text-white hover:bg-slate-800 rounded-full px-6"
              data-testid="header-start-btn"
            >
              Start Now
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className={`md:hidden p-2 ${textColor}`}
            data-testid="mobile-menu-btn"
          >
            {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-slate-200 bg-white">
            <div className="flex flex-col gap-4">
              <Link to="/pricing" className="text-slate-900 font-medium px-2 py-2" onClick={() => setMobileMenuOpen(false)}>
                Pricing
              </Link>
              <Link to="/samples" className="text-slate-900 font-medium px-2 py-2" onClick={() => setMobileMenuOpen(false)}>
                Samples
              </Link>
              <Link to="/faq" className="text-slate-900 font-medium px-2 py-2" onClick={() => setMobileMenuOpen(false)}>
                FAQ
              </Link>
              <Button 
                onClick={() => { navigate('/start'); setMobileMenuOpen(false); }} 
                className="bg-slate-900 text-white mx-2"
              >
                Start Now
              </Button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
